var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel page__investors"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"p-0"},[_c('ExchangeOptions'),(false)?_c('CorrelationChart'):_vm._e(),_c('FunctionCharts')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }